import React, { useContext, useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";
import {
  Restaurant,
  Store,
  AccountCircle,
  Brightness4,
  Brightness7,
  RotateLeft,
  ExitToApp,
  Settings,
} from "@material-ui/icons";
import SwitchComp from "../../SwitchComponent";
import { ThemeContext } from "../../../../Context/Theme";
import { Auth } from "aws-amplify";
import { AuthContext } from "../../../../Context/Auth";
import { withRouter } from "react-router";
import { RouteContext } from "../../../../Context/RouteContext";
import { RestaurantContext } from "../../../../Context/RestaurantData";
import LockSettingButton from "../../LockSettingButton";

import OpenSnackbar from "../../../../Shared/OpenSnackbar";
import { Instance } from "../../../../Context/axiosContext";
const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.common.white,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.black,
      },
    },
  },
}))(MenuItem);

const MobileMenu = ({
  anchorEl,
  handleClose,
  switchValue,
  handleSwitch,
  history,
  getRestStatus,
}) => {
  const axiosInstance = Instance();
  const { dark, toggle } = useContext(ThemeContext);
  const { restaurantData } = useContext(RestaurantContext);
  const { logout, user } = useContext(AuthContext);
  const { resetRoute } = useContext(RouteContext);
  const mode = localStorage.getItem("mode");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };

  function signOut() {
    Auth.signOut()
      .then((data) => {
        logout();
        localStorage.clear();
        resetRoute();
      })
      .catch((err) => {});
  }

  const changeRestStatus = async () => {
    axiosInstance
      .get(
        process.env.REACT_APP_API_URL +
          `restaurant/test-id/${
            restaurantData.restaurant_open ? "close" : "open"
          }`,
        {
          headers: {
            Authorization: user,
            ["x-api-key"]: localStorage.getItem("apikey"),
          },
        }
      )
      .then((data) => {
        getRestStatus();
        handleSwitch();
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.error === "Unauthorized") {
          handleSnackbarOpen(
            "Please disable settings lock to make changes..😥",
            "errorDark"
          );
          return;
        }
      });
  };

  return (
    <div>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        data-testid={`userActionButton`}
      >
        <StyledMenuItem>
          <ListItemIcon>
            <Store fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            <FormGroup onClick={changeRestStatus}>
              <FormControlLabel
                control={
                  <SwitchComp
                    checked={switchValue}
                    onChange={handleSwitch}
                    name="switchValue"
                    disabled={restaurantData.lock_setting}
                  />
                }
                label={switchValue ? "OPENED" : "CLOSED"}
              />
            </FormGroup>
          </ListItemText>
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() =>
            window.location.replace(
              `${process.env.REACT_APP_STAGE}/${restaurantData?.slug}`
            )
          }
        >
          <ListItemIcon>
            <Restaurant fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={restaurantData?.name || ""} />
        </StyledMenuItem>
        <StyledMenuItem data-testid={`darkModeButton`} onClick={toggle}>
          <ListItemIcon>
            {!dark ? <Brightness4 /> : <Brightness7 />}
          </ListItemIcon>
          <ListItemText
            primary={dark ? "Toggle light mode" : "Toggle dark mode"}
          />
        </StyledMenuItem>

        {mode === "superadmin" && (
          <StyledMenuItem onClick={signOut}>
            <ListItemIcon>
              <AccountCircle fontSize="small" />
            </ListItemIcon>
            <ListItemText
              style={{ color: "red" }}
              primary="End Superadmin Session"
            />
          </StyledMenuItem>
        )}

        <StyledMenuItem
          data-testid={`resetPasswordButton`}
          onClick={() => history.push("/reset-password")}
        >
          <ListItemIcon>
            <RotateLeft fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Reset Password" />
        </StyledMenuItem>
        <StyledMenuItem data-testid={`logoutButton`} onClick={signOut}>
          <ListItemIcon>
            <ExitToApp fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </StyledMenuItem>
        {restaurantData.lock_setting !== undefined && (
          <StyledMenuItem>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            <div>
              <LockSettingButton
                status={restaurantData.lock_setting}
                getRestStatus={getRestStatus}
              />
            </div>
            <ListItemText
              primary={restaurantData.lock_setting ? "Locked" : "Unlocked"}
            ></ListItemText>
          </StyledMenuItem>
        )}
      </StyledMenu>
      {snackbarOpen && (
        <OpenSnackbar
          message={snackbarDetails.message}
          type={snackbarDetails.type}
          open={snackbarOpen}
          setOpen={setSnackbarOpen}
          vertical="bottom"
          horizontal="center"
        />
      )}
    </div>
  );
};

export default withRouter(MobileMenu);
